import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileCheck } from "lucide-react";
import api from "../lib/api";
import StatusBadge from "../components/StatusBadge";

export default function MieRichiestePage() {
  const [richieste, setRichieste] = useState(null);

  useEffect(() => {
    api.get("/agibilita/mie").then((res) => setRichieste(res.data)).catch(() => setRichieste([]));
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8" data-testid="mie-richieste-page">
      <h1 className="section-title">Le mie richieste</h1>
      <p className="mt-3 text-muted-foreground">Lo storico completo delle tue richieste di certificato di agibilità.</p>

      {richieste === null ? (
        <p className="mt-10 text-sm text-muted-foreground">Caricamento...</p>
      ) : richieste.length === 0 ? (
        <div className="card-elegant mt-8 text-center" data-testid="mie-richieste-empty">
          <FileCheck className="mx-auto h-10 w-10 text-bordeaux/40" />
          <p className="mt-3 text-sm text-muted-foreground">Non hai ancora effettuato richieste di agibilità.</p>
          <Link to="/richiedi-agibilita" data-testid="mie-richieste-new-btn" className="btn-bordeaux mt-5">
            RICHIEDI CERTIFICATO DI AGIBILITÀ
          </Link>
        </div>
      ) : (
        <div className="mt-8 space-y-4">
          {richieste.map((r) => (
            <Link
              key={r.id}
              to={`/le-mie-richieste/${r.id}`}
              data-testid={`richiesta-card-${r.numero_pratica}`}
              className="card-elegant block !p-5"
            >
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="font-heading text-lg font-bold text-bordeaux-dark">{r.numero_pratica}</p>
                  <p className="mt-1 text-sm text-muted-foreground">
                    Richiesta del {new Date(r.created_at).toLocaleDateString("it-IT")} · Esibizione del{" "}
                    {new Date(r.data_esibizione).toLocaleDateString("it-IT")}
                  </p>
                </div>
                <StatusBadge stato={r.stato} />
              </div>
              <div className="mt-3 flex flex-wrap gap-x-6 gap-y-1 text-sm text-foreground/80">
                <span><strong>Locale:</strong> {r.nome_locale}</span>
                <span><strong>Attività:</strong> {r.attivita}</span>
                <span><strong>Importo:</strong> € {r.importo.toFixed(2)}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
